import React, { FC } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import NumberField from '@cld/number-field';
import { typography } from '@cld/typography';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { messages } from '../../../i18n';
import { updateOptions } from '../../../actions';
import { useOptions } from '../../../selectors';
import { Section } from '../common/Section';

const SelectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SelectionLabel = styled.div`
  ${typography.xs.regular};
`;

const SelectionNumberField = styled(NumberField)`
  width: 55px;
`;

export interface SelectionProps {
  maxFiles?: string;
}
export const Selection: FC = () => {
  const analytics = useAnalytics();

  const { formatMessage } = useIntl();
  const { maxFiles } = useOptions();
  const dispatch = useDispatch();

  const handleOnChange = (value: string) => {
    const numberOfAssets = parseInt(value, 10);
    if (value === '' || (!isNaN(numberOfAssets) && numberOfAssets >= 1 && numberOfAssets <= 20)) {
      analytics('edit asset selection', `change number of assets to ${value}`);
      dispatch(updateOptions({ maxFiles: value }));
    }
  };

  return (
    <Section title={formatMessage(messages['demo.section.selection'])}>
      <SelectionContainer>
        <SelectionLabel>
          <FormattedMessage {...messages['demo.section.maximumAssets']} />
        </SelectionLabel>
        <SelectionNumberField data-test="max-files" min={1} max={20} step={1} value={maxFiles} onChange={handleOnChange} />
      </SelectionContainer>
    </Section>
  );
};
